<template>
  <modal
    class="cart-modal"
    bodyClasses="mt-2"
    :show.sync="showCartModal"
    @close="closeModal"
    headerClasses="pb-0"
    :showClose="true"
  >
    <h6 slot="header" class="modal-title" id="modal-title-default">Cart</h6>

    <div v-if="stripe.cartItems.length">
      <div v-for="item in stripe.cartItems" v-bind:key="item.id">
        <div v-if="!item.is_design_service_only" class="cart-row">
          <div class="thumbnail">
            <router-link
              @click.native="handleLinkClick"
              :to="artworkLink(item.artwork_id, item.type, item.artist)"
              ><img :src="item.thumbnail"
            /></router-link>
          </div>
          <div v-if="unavailable.includes(item.artwork_id)" class="details-col">
            <badge type="danger">UNAVAILABLE</badge>
          </div>
          <div v-else class="details-col">
            <div>
              <strong>
                {{ itemId(item.type) }}
                <!-- #{{ item.artwork_id }} -->
              </strong>
            </div>
            <div v-if="item.is_upgrade">License upgrade</div>
            <div v-else>
              {{
                item.license === "6mo" ? "6 month license" : "Forever license"
              }}
            </div>
          </div>
          <div class="price-col">
            <span v-if="!unavailable.includes(item.artwork_id)"
              >${{ item.price }}</span
            >
          </div>
          <div class="remove-col">
            <button @click="handleDelete(item.id)">
              <i title="Remove from cart" class="fa fa-trash-alt"></i>
            </button>
          </div>
        </div>
        <div v-if="item.design_service" class="service-row">
          <div class="thumbnail">
            <img :src="item.thumbnail" />
            <i class="fas fa-pencil-ruler service-icon"></i>
          </div>
          <div class="details-col">
            <div>
              <strong> Design Service </strong>
            </div>
            <div>
              {{
                item.design_service === "design_one"
                  ? "One Revision"
                  : "Two Revisions"
              }}
            </div>
          </div>
          <div class="price-col">
            {{ item.design_service === "design_one" ? "$25.00" : "$40.00" }}
          </div>
          <div class="remove-col">
            <button @click="handleDelete(item.id, true)">
              <i title="Remove from cart" class="fa fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-if="unavailable.length === 0" class="total-row">
        <div class="service-fee">
          Service Fee:
          <span class="ml-2">${{ stripe.cartFees }}</span>
        </div>
        <div>
          <small>Total:</small>
          <strong class="ml-2">${{ stripe.cartTotal }}</strong>
        </div>
      </div>
      <div v-else class="purchase-errors">
        Some items in your cart are no longer available. Please remove them to
        continue.
      </div>
    </div>
    <div v-else class="text-center p-5">There are no items in your cart.</div>
    <div slot="footer" class="w-100">
      <base-button
        type="primary"
        @click="handleCheckout"
        class="mt-4 add-service-button"
        block
        size="lg"
        :disabled="!stripe.cartItems.length || unavailable.length > 0"
        :loading="loading"
        >CHECKOUT</base-button
      >
    </div>
  </modal>
</template>

<script>
import { mapState } from "vuex";
import swal from "sweetalert2";

const apiBaseURL = process.env.VUE_APP_API_URL;

export default {
  name: "cart-modal",
  data() {
    return {
      updatingCart: false,
      loading: false,
    };
  },
  methods: {
    handleLinkClick() {
      this.$store.commit("showCart", false);
    },
    handleCheckout() {
      this.closeModal();
      this.$router.push({ path: "/checkout" });
    },
    closeModal() {
      // Close modal
      this.$store.commit("showCart", false);
    },
    itemId(type) {
      if (type === "pro") return "PRO File";
      return type.charAt(0).toUpperCase() + type.slice(1);
    },
    artworkLink(id, type, artist) {
      return `/${type === "animation" ? "animation" : "art"}/${artist}/${id}`;
    },
    showErrorAlert(message) {
      swal.fire({
        type: "error",
        title: "Oh no!",
        text: message,
        confirmButtonColor: "#000",
      });
    },
    handleDelete(id, removeDesignService = false) {
      swal
        .fire({
          title: "ARE YOU SURE?",
          text: "Are you sure you want to remove this item?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#000",
          cancelButtonColor: "#f5365c",
          confirmButtonText: "YES, REMOVE IT",
        })
        .then((result) => {
          if (result.value) {
            this.updatingCart = true;
            this.axios
              .post(`${apiBaseURL}/api/artv1.1/user/removefromcart`, {
                id,
                removeDesignService,
              })
              .then((result) => {
                if (result.data.data.message === "Success") {
                  this.$store.dispatch("getCart");
                } else if (result.data.data.api_action_error) {
                  this.showErrorAlert(
                    `There was a problem removing this item from your cart. Please try again, or contact Art Grab support for help.`
                  );
                }
              })
              .catch((error) => {
                /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
                console.error(error);
              })
              .finally(() => {
                this.updatingCart = false;
              });
          }
        });
    },
  },
  props: {},
  computed: {
    ...mapState(["isLoggedIn", "stripe", "showCart"]),
    unavailable() {
      return this.stripe.cartUnavailable;
    },
    showCartModal: {
      get() {
        return this.$store.state.showCart;
      },
      set(value) {
        this.$store.commit("showCart", value);
      },
    },
  },
};
</script>

<style lang="scss">
.cart-modal {
  .modal-content {
    max-height: 80vh;
    overflow: hidden;
  }

  .purchase-errors {
    font-size: 0.875rem;
    color: red;
    text-align: center;
    width: 80%;
    margin: 20px auto 0;
  }

  .modal-body {
    overflow-y: auto;
    padding-bottom: 90px;
  }

  .modal-footer {
    padding-top: 0;
    padding-bottom: 15px;
    background-color: rgba(255, 255, 255, 0.85);
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  .total-row {
    font-size: 1.25rem;
    text-align: right;
    padding-right: 27px;

    .service-fee {
      font-size: 16px;
    }
  }

  // .service-row {
  //   display: flex;
  //   margin-bottom: 16px;
  //   justify-content: space-between;
  //   align-items: center;
  // }

  .cart-row,
  .service-row {
    display: flex;
    margin-bottom: 16px;
    align-items: center;

    .details-col {
      display: flex;
      flex-direction: column;
      padding-left: 10px;
    }

    .price-col {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 1.25rem;
      // font-weight: bold;
    }

    .remove-col {
      display: flex;
      align-items: center;

      button {
        background: none;
        border: none;
        padding: 8px;
        color: rgb(255, 81, 81);
        font-size: 14px;

        &:hover,
        &:active,
        &:focus {
          outline: none;
        }
      }
    }

    .service-icon {
      position: absolute;
      top: 17px;
      left: 16px;
      color: white;
      font-size: 18px;
    }

    .thumbnail {
      overflow: hidden;
      border-radius: 4px;
      width: 50px;
      height: 50px;
      position: relative;

      img {
        width: 50px;
        height: 50px;
        object-fit: cover;
        object-position: center;
      }
    }
  }
}

@media (max-width: 575.98px) {
  .cart-modal {
    .purchase-errors {
      width: 100%;
    }
  }
}
</style>
